import { useEffect, useState } from "react";
import api from "../lib/api";
import dayjs from "dayjs";
import { ChevronLeft, ChevronRight, Loader2 } from "lucide-react";

const LEVEL_STYLES = {
  low: "bg-[#f0f9f0] border-[#009900]/40 text-[#005125]",
  medium: "bg-white border-[#e2ebe4] text-[#144733]",
  high: "bg-amber-50 border-amber-300 text-amber-800",
};

export const RateCalendar = ({ onPick }) => {
  const [month, setMonth] = useState(dayjs().startOf("month"));
  const [days, setDays] = useState(null);

  useEffect(() => {
    setDays(null);
    api.get("/rate-calendar", { params: { year: month.year(), month: month.month() + 1 } })
      .then((r) => setDays(r.data.days))
      .catch(() => setDays([]));
  }, [month]);

  const firstDow = month.day();
  const isCurrentMonth = month.isSame(dayjs().startOf("month"), "month");

  return (
    <div className="border border-[#e2ebe4] rounded-lg bg-[#fafcfa] p-4" data-testid="rate-calendar">
      <div className="flex items-center justify-between mb-3">
        <button type="button" disabled={isCurrentMonth} onClick={() => setMonth(month.subtract(1, "month"))}
          className="p-1.5 rounded border border-[#d5ddd5] disabled:opacity-30 hover:border-[#009900]" data-testid="rate-cal-prev">
          <ChevronLeft className="w-4 h-4" />
        </button>
        <span className="heading-upper text-sm tracking-widest text-[#144733]" data-testid="rate-cal-month">{month.format("MMMM YYYY")}</span>
        <button type="button" onClick={() => setMonth(month.add(1, "month"))}
          className="p-1.5 rounded border border-[#d5ddd5] hover:border-[#009900]" data-testid="rate-cal-next">
          <ChevronRight className="w-4 h-4" />
        </button>
      </div>

      {days === null ? (
        <div className="flex justify-center py-10"><Loader2 className="w-5 h-5 animate-spin text-[#009900]" /></div>
      ) : (
        <>
          <div className="grid grid-cols-7 gap-1 text-center text-[10px] uppercase tracking-wide text-[#8a978f] mb-1">
            {["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"].map((d) => <span key={d}>{d}</span>)}
          </div>
          <div className="grid grid-cols-7 gap-1">
            {Array.from({ length: firstDow }).map((_, i) => <span key={`b${i}`} />)}
            {days.map((d) => {
              const disabled = d.past;
              return (
                <button
                  key={d.date}
                  type="button"
                  disabled={disabled}
                  onClick={() => onPick(d.date)}
                  className={`border rounded p-1.5 text-center transition-colors ${disabled ? "bg-[#f1f3f1] border-[#e2ebe4] text-[#c3ccc6] cursor-not-allowed" : `${LEVEL_STYLES[d.level]} hover:border-[#009900] cursor-pointer`}`}
                  data-testid="rate-cal-day"
                  data-date={d.date}
                >
                  <div className="text-xs font-bold">{dayjs(d.date).date()}</div>
                  {!disabled && <div className="text-[9px] font-medium">AED {d.from_price}</div>}
                </button>
              );
            })}
          </div>
          <div className="flex gap-4 mt-3 text-[10px] text-[#57685e]">
            <span className="flex items-center gap-1"><span className="w-3 h-3 rounded-sm bg-[#f0f9f0] border border-[#009900]/40 inline-block" /> Low rates</span>
            <span className="flex items-center gap-1"><span className="w-3 h-3 rounded-sm bg-white border border-[#e2ebe4] inline-block" /> Standard</span>
            <span className="flex items-center gap-1"><span className="w-3 h-3 rounded-sm bg-amber-50 border border-amber-300 inline-block" /> High demand</span>
            <span className="ml-auto">Prices = cheapest vehicle per day</span>
          </div>
        </>
      )}
    </div>
  );
};
